import {MeiliSearch} from "meilisearch";

const processItemFromMeilisearch = (i) => ({
	title: i.title,
	content: i.content,
	author: i.authorTitle,
	authorId: i.author,
	id: i.id,
	isChecked: i.source === "kytaristka",
	source: i.source,
	link: i.sourceLink
})

export class ExternalSearchService {
	static getIndex() {
		const meilisearch = new MeiliSearch({
			host: "https://meilisearch.mangozpevnik.cz",
			apiKey: "1DJLz8FGe89c7cb8cc8071d8a508269ca95706561bcbdb8580ce2eac63dc3d962bf6c525"
		})

		return meilisearch.index("songs")
	}

	static async search({ query, signal, limit, offset = 0 }) {
		try {
			const response = await this.getIndex().search(query, { limit, offset }, { signal } )
			return response.hits.map(processItemFromMeilisearch)
		} catch (e) {
			return []
		}
	}

	static async getSong(id) {
		return processItemFromMeilisearch(await this.getIndex().getDocument(id))
	}
}
